import mutate from 'js-core/js/apollo/mutations/mutate';
import invalidateQuery from 'js-core/js/apollo/mutations/invalidateQuery';

import CloseCohort from 'gql/mutations/Cohort/CloseCohort.gql';

export default class{

    static closeCohort(cohortId) {

        return mutate(CloseCohort, { cohortId }, store => {

            invalidateQuery(store, 'allParcels');
        });
    }
}
